import { T } from "services/lang/LanguageService";
import {
  DATE_PATTERN_HOURS,
  DATE_PATTERN_MINUTES,
  DATE_PATTERN_NO_TIME,
  DATE_PATTERN_SECONDS,
} from "utils/constants";

export enum XAxisType {
  CATEGORY = "category",
  DATE = "date",
  ARRAY = "array",
}

export const XAxisTypeOptions = [
  { label: T("word.category"), value: XAxisType.CATEGORY },
  { label: T("word.date"), value: XAxisType.DATE },
];

export enum DateFormat {
  NO_TIME = "%Y-%m-%d",
  SECONDS = "%Y-%m-%d %H:%M:%S",
  MINUTES = "%Y-%m-%d %H:%M",
  HOURS = "%Y-%m-%d %H",
}

export const DatePatternOptions = [
  { label: "yyyy-MM-dd", value: DateFormat.NO_TIME },
  { label: "yyyy-MM-dd HH", value: DateFormat.HOURS },
  { label: "yyyy-MM-dd HH:mm", value: DateFormat.MINUTES },
  { label: "yyyy-MM-dd HH:mm:ss", value: DateFormat.SECONDS },
];

export const CategoryPatternOptions = [
  { label: "yyyy-MM-dd", value: DATE_PATTERN_NO_TIME },
  { label: "yyyy-MM-dd HH", value: DATE_PATTERN_HOURS },
  { label: "yyyy-MM-dd HH:mm", value: DATE_PATTERN_MINUTES },
  { label: "yyyy-MM-dd HH:mm:ss", value: DATE_PATTERN_SECONDS },
];
